// Répétition espacée : l'algorithme SM-2 (celui d'Anki à l'origine), en ~40 lignes.
// Règle R-CAR-03. Notes : 1 = oublié, 3 = difficile, 4 = bien, 5 = facile.
import type { EtatCarte, NoteRevision } from './types';
import { ajouterJours } from './dates';

export const FACILITE_INITIALE = 2.5;
export const FACILITE_MINIMALE = 1.3;

/** Une carte qui vient d'être activée : due dès aujourd'hui. */
export function nouvelleCarte(aujourdhui: string, options: Partial<EtatCarte> = {}): EtatCarte {
  return {
    actif_depuis: aujourdhui,
    intervalle: 0,
    facilite: FACILITE_INITIALE,
    repetitions: 0,
    echeance: aujourdhui,
    suspendue: false,
    manuelle: false,
    ...options,
  };
}

/**
 * Applique une révision et renvoie le nouvel état de la carte.
 * - note < 3 : on repart de zéro (revue demain) ;
 * - sinon : 1 jour, puis 6 jours, puis intervalle × facilité ;
 * - la facilité monte si c'est facile, descend si c'est dur, jamais sous 1,3.
 */
export function reviser(carte: EtatCarte, note: NoteRevision, aujourdhui: string): EtatCarte {
  let { intervalle, facilite, repetitions } = carte;

  if (note < 3) {
    repetitions = 0;
    intervalle = 1;
  } else {
    if (repetitions === 0) intervalle = 1;
    else if (repetitions === 1) intervalle = 6;
    else intervalle = Math.round(intervalle * facilite);
    repetitions += 1;
  }

  const ecart = 5 - note;
  facilite = Math.max(FACILITE_MINIMALE, facilite + 0.1 - ecart * (0.08 + ecart * 0.02));

  return {
    ...carte,
    intervalle,
    facilite: Math.round(facilite * 100) / 100,
    repetitions,
    echeance: ajouterJours(aujourdhui, intervalle),
  };
}

/** Une carte est due si elle est active, non suspendue et que son échéance est passée. */
export function estDue(carte: EtatCarte, aujourdhui: string): boolean {
  return !carte.suspendue && carte.echeance <= aujourdhui;
}

/** Une carte « nouvelle » n'a jamais été révisée. */
export function estNouvelle(carte: EtatCarte): boolean {
  return carte.repetitions === 0 && carte.intervalle === 0;
}
